import { Suspense } from "react";
import { Routes as RouterRoutes, Route, useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import { Loading, ErrorFallback, BulkOrder, OrderTemplateCart } from "@ten24/slatwall-storefront-react-private/global";
import OrderConfirmation from "./pages/OrderConfirmation/OrderConfirmation";
import { useContentContext } from "./contexts/ContentContext";
import Checkout from "./pages/Checkout/Checkout";
import DynamicPage from "./pages/DynamicPage/DynamicPage";
import { storefrontContentService } from "./services/storefrontService.class";
import { reciveConfiguration } from "@ten24/slatwall-storefront-react-private/global";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import MyAccount from "./pages/MyAccount/MyAccount";
import Cart from "./pages/Cart/Cart";
import Quote from "./pages/Quote/Quote";
import Manufacturer from "./pages/Manufacturer/Manufacturer";
import BrandPage from "./pages/Brand";
import CategoryPage from "./pages/Category";
import ProductTypePage from "./pages/ProductType";
import ShopPage from "./pages/Shop";
import ProductPage from "./pages/Product";

const Routes = Sentry.withSentryReactRouterV6Routing(RouterRoutes);

const pageComponents = {
  Product: <ProductPage />,
  ProductType: <ProductTypePage />,
  Category: <CategoryPage />,
  Brand: <BrandPage />,
};

//https://itnext.io/react-router-transitions-with-lazy-loading-2faa7a1d24a
export default function App() {
  const dispatch = useDispatch();
  const routing = useSelector((state) => state.configuration.router);
  const loc = useLocation();
  const shopByManufacturer = useSelector((state) => state.configuration.shopByManufacturer);
  const pageData = useContentContext();
  const siteSetting = useSelector((state) => state.configuration.site.settings);
  // eslint-disable-next-line no-unused-vars
  // const cms = useCMSWrapper()
  // eslint-disable-next-line no-unused-vars

  // Load new site config
  let oldSiteConfig = useSelector((state) => state.configuration.site);
  const cmsApiUrl = useSelector((state) => state.configuration?.site?.customAttributes?.cmsUrl);
  const service = new storefrontContentService(cmsApiUrl);
  useEffect(() => {
    service.fetchNewConfig(oldSiteConfig, pageData?.styleOverrides).then((newConfig) => {
      dispatch(reciveConfiguration(newConfig));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageData]);

  // const scroll = useScrollToTop()
  if (pageData?.contentID === null || pageData?.contentID === undefined) return null;

  return (
    <Suspense fallback={<Loading />}>
      <ErrorBoundary
        key={loc.pathname}
        FallbackComponent={ErrorFallback}
        onReset={() => {
          // reset the state of your app so the error doesn't happen again
        }}
      >
        {/* <SEO /> */}

        <Routes>
          <Route path="/404" element={<DynamicPage />} />
          <Route path={shopByManufacturer.slug} element={<Manufacturer />} />
          {routing?.map(({ URLKey, URLKeyType }, index) => {
            return (
              !!pageComponents[URLKeyType] && (
                <Route key={index} path={`/${URLKey}/:id`} element={pageComponents[URLKeyType]} />
              )
            );
          })}
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/range/:id" element={<ProductTypePage />} />
          <Route path="/bulkorder" element={<BulkOrder />} />
          <Route path="/my-account/*" element={<MyAccount />} />
          <Route path="/checkout/*" element={siteSetting.sitePurpose !== "Non-Transactional" && <Checkout />} />
          <Route path="/shopping-cart" element={siteSetting.sitePurpose !== "Non-Transactional" && <Cart />} />
          <Route path="/quotes-in-cart" element={siteSetting.sitePurpose !== "Non-Transactional" && <Quote />} />
          <Route
            path="/order-confirmation"
            element={siteSetting.sitePurpose !== "Non-Transactional" && <OrderConfirmation />}
          />
          <Route
            path="/scheduled-delivery-cart"
            element={siteSetting.sitePurpose !== "Non-Transactional" && <OrderTemplateCart />}
          />
          <Route path={"*"} element={<DynamicPage />} />
          <Route index element={<DynamicPage />} />
        </Routes>
      </ErrorBoundary>
    </Suspense>
  );
}
